<ll-titulo>
    {{ evaluacionTipoAlias | titlecase }}
    {{ "evaluacion_recomendada.recomendadas" | t | genderize: tipoInstrumento }}
</ll-titulo>

<evaluaciones-recomendadas-alumno
    [showEvaluacionMultiple]="true"
    [evaluacionTipo]="tipoInstrumento"
></evaluaciones-recomendadas-alumno>
